module.exports = __webpack_public_path__ + "img/资源整合@2x.170974ba.png";